var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlerts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5589 2.47863C16.7246 2.1924 17.85 3.07492 17.85 4.27526V12.7349C17.85 13.9293 16.735 14.8107 15.5728 14.5349L3.57279 11.6867C2.73882 11.4887 2.15002 10.7438 2.15002 9.88668V7.22169C2.15002 6.36988 2.73165 5.62817 3.55889 5.42506L15.5589 2.47863ZM16.15 4.27526C16.15 4.17794 16.0588 4.10638 15.9643 4.12959L3.96426 7.07602C3.89718 7.09249 3.85002 7.15263 3.85002 7.22169V9.88668C3.85002 9.95618 3.89776 10.0166 3.96538 10.0326L15.9654 12.8808C16.0596 12.9032 16.15 12.8317 16.15 12.7349V4.27526Z",
    fill: "#6D7284"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00002 14.15C6.46947 14.15 6.85002 14.5306 6.85002 15V17.15H11.15V16.7143C11.15 16.2449 11.5306 15.8643 12 15.8643C12.4695 15.8643 12.85 16.2449 12.85 16.7143V18C12.85 18.4695 12.4695 18.85 12 18.85H6.00002C5.53058 18.85 5.15002 18.4695 5.15002 18V15C5.15002 14.5306 5.53058 14.15 6.00002 14.15Z",
    fill: "#6D7284"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.c3d60026.svg";
export { ForwardRef as ReactComponent };